var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "107px",
        height: "108px",
        viewBox: "0 0 107 108",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("title", [_vm._v("icons/pills/pill-back@1,5x")]),
      _vm._v(" "),
      _c("desc", [_vm._v("Created with Sketch.")]),
      _vm._v(" "),
      _c("defs", [
        _c("path", {
          attrs: {
            d:
              "M105.341,90.682 C105.341,98.966 98.625,105.682 90.341,105.682 L15.424,105.682 C7.14,105.682 0.424,98.966 0.424,90.682 L0.424,15 C0.424,6.715 7.14,0 15.424,0 L90.341,0 C98.625,0 105.341,6.715 105.341,15 L105.341,90.682 Z",
            id: "path-btl-1"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M52.994283,23 C53.149505,23 53.2934382,23.022386 53.4430158,23.0531667 C53.5982379,23.0811491 53.7478155,23.1147281 53.8945709,23.1734913 C54.0328596,23.2294562 54.1542151,23.3078071 54.2812149,23.3889563 C54.3743482,23.4477194 54.4815925,23.4757019 54.5690813,23.5484563 C54.7751033,23.7275441 71.4092637,38.3371887 67.1731126,60.6588005 C68.6039778,62.4105028 75.3998818,71.4264528 72.1119963,80.7334204 C71.8777521,81.399403 71.3584638,81.9282716 70.6952423,82.1717191 C70.421487,82.2780524 70.1336206,82.3256226 69.8485765,82.3256226 C69.4393547,82.3256226 69.0357773,82.2248857 68.671711,82.0206137 L68.671711,82.0206137 L60.3264086,77.3615334 C59.8776758,77.868016 59.2342098,78.1786214 58.5399438,78.1786214 L58.5399438,78.1786214 L55.4157471,78.1786214 L55.4157471,80.6242888 C55.4157471,81.9394646 54.3433038,83 53.0168607,83 C51.6932399,83 50.6179743,81.9394646 50.6179743,80.6242888 L50.6179743,80.6242888 L50.6179743,78.1786214 L47.459911,78.1786214 C46.7628228,78.1786214 46.122179,77.868016 45.6706239,77.3615334 L45.6706239,77.3615334 L37.3281437,82.0206137 C36.9640775,82.2248857 36.5605001,82.3256226 36.1512783,82.3256226 C35.8662342,82.3256226 35.5783678,82.2780524 35.3046125,82.1717191 C34.641391,81.9282716 34.1221026,81.399403 33.8878584,80.7362186 C30.5915063,71.4012685 37.4325659,62.3601343 38.8380311,60.642011 C37.1136551,51.5840873 38.8041644,43.9644623 41.1014509,38.4435221 C44.9622469,29.1561422 51.1711293,23.772316 51.4335957,23.5484563 C51.5210845,23.4757019 51.6255066,23.4505177 51.7186398,23.3889563 C51.8428175,23.3078071 51.9641729,23.2322545 52.0996394,23.1762895 C52.2520393,23.1147281 52.4072613,23.0783509 52.5681278,23.0503684 C52.7092388,23.022386 52.8475275,23 52.994283,23 Z M65.5249365,66.73939 C64.7911595,68.8492678 63.8626494,71.0179088 62.7168284,73.2397164 L62.7168284,73.2397164 L68.1721782,76.2842086 C68.4205335,72.632497 66.9275795,69.1626714 65.5249365,66.73939 Z M40.4862071,66.7449865 C39.0863864,69.1710661 37.5934324,72.6464882 37.833321,76.2814103 L37.833321,76.2814103 L43.2830264,73.2397164 C42.1372054,71.0151105 41.2171619,68.8492678 40.4862071,66.7449865 Z M52.9999274,28.6748438 C48.2529546,33.6641172 35.3638791,50.3528589 48.8230429,73.4244007 L48.8230429,73.4244007 L50.6179743,73.4244007 L50.6179743,67.1059603 C50.6179743,65.7907844 51.6932399,64.7274508 53.0168607,64.7274508 C54.3433038,64.7274508 55.4157471,65.7907844 55.4157471,67.1059603 L55.4157471,67.1059603 L55.4157471,73.4244007 L57.1768119,73.4244007 C70.6331534,50.3528589 57.7469002,33.6641172 52.9999274,28.6748438 Z M53.0352169,43.5061095 C57.3899012,43.5061095 60.9346086,47.0179088 60.9346086,51.3384013 C60.9346086,55.6588938 57.3899012,59.170693 53.0352169,59.170693 C48.6805325,59.170693 45.1358251,55.6588938 45.1358251,51.3384013 C45.1358251,47.0179088 48.6805325,43.5061095 53.0352169,43.5061095 Z M53.0352169,47.1102509 C50.6843082,47.1102509 48.7708435,49.007462 48.7708435,51.3384013 C48.7708435,53.6693405 50.6843082,55.5693499 53.0352169,55.5693499 C55.3861255,55.5693499 57.2995902,53.6693405 57.2995902,51.3384013 C57.2995902,49.007462 55.3861255,47.1102509 53.0352169,47.1102509 Z",
            id: "path-btl-3"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Desktop-HD",
                transform: "translate(-1506.000000, -412.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "icons/pills/pill-back",
                    transform: "translate(1507.000000, 413.000000)"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "colors/color-fleet",
                        "stroke-width": "1",
                        "fill-rule": "evenodd"
                      }
                    },
                    [
                      _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                        _c("use", { attrs: { "xlink:href": "#path-btl-1" } })
                      ]),
                      _vm._v(" "),
                      _c("use", {
                        attrs: {
                          id: "Mask",
                          stroke: "#C0C6CC",
                          "xlink:href": "#path-btl-1"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("mask", { attrs: { id: "mask-4", fill: "white" } }, [
                    _c("use", { attrs: { "xlink:href": "#path-btl-3" } })
                  ]),
                  _vm._v(" "),
                  _c("use", {
                    attrs: {
                      id: "Mask",
                      fill: "#6C6C6C",
                      "fill-rule": "evenodd",
                      "xlink:href": "#path-btl-3"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "colors/greys/80",
                        mask: "url(#mask-4)",
                        fill: "#ABB1B8",
                        "fill-rule": "evenodd"
                      }
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            transform: "translate(20.000000, 20.000000)",
                            id: "Fill-10-Copy-2"
                          }
                        },
                        [
                          _c("polygon", {
                            attrs: {
                              points:
                                "0 68 68 68 68 2.58840568e-14 0 2.58840568e-14"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }